import UPInput from 'components/input';
import { formatKioskTimeInput } from 'modules/kiosk/kiosk-time-input';
import { useTranslation } from 'react-i18next';
import { CONTRACT_COMPLIANCE__END_TIME, CONTRACT_COMPLIANCE__START_TIME } from 'translations/constants';
import { IntervalDraft, IntervalErrors } from './interval';
import { IntervalRow } from './styles';

interface IntervalFieldsProps {
  value: IntervalDraft;
  onChange: (field: keyof IntervalDraft, value: string) => void;
  errors: IntervalErrors;
  disabled?: boolean;
  required?: boolean;
  testIdPrefix: string;
}

const TIME_PLACEHOLDER = 'HH:mm';
const TIME_MAX_LENGTH = 5;

const IntervalFields = ({
  value,
  onChange,
  errors,
  disabled,
  required,
  testIdPrefix,
}: IntervalFieldsProps): JSX.Element => {
  const [t] = useTranslation();

  const renderTime = (field: keyof IntervalDraft, labelKey: string) => {
    const errorKey = errors[field];
    return (
      <UPInput
        value={value[field]}
        onChange={event => onChange(field, formatKioskTimeInput(value[field], event.target.value))}
        label={t(labelKey)}
        placeholder={TIME_PLACEHOLDER}
        maxLength={TIME_MAX_LENGTH}
        autoComplete="off"
        error={!!errorKey}
        helperText={errorKey ? t(errorKey) : ''}
        disabled={disabled}
        required={required}
        testId={`${testIdPrefix}-${field}-time`}
      />
    );
  };

  return (
    <IntervalRow>
      {renderTime('start', CONTRACT_COMPLIANCE__START_TIME)}
      {renderTime('end', CONTRACT_COMPLIANCE__END_TIME)}
    </IntervalRow>
  );
};

IntervalFields.defaultProps = {
  disabled: false,
  required: false,
};

export default IntervalFields;
